import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import { Fields as RedeemTemplate } from 'models/RedeemTemplate'
import React from 'react'
import { getMultiUseSettings } from 'scenes/RedeemManager/helpers'
import Card from './Card'

type PropsT = {
  template: RedeemTemplate
}

const t = buildTranslate('redeem_manager.detail.cards.multi_use')

const MultiUseCard: React.FC<PropsT> = ({ template }) => {
  const multiUseSettings = getMultiUseSettings(template.multi_use_settings)
  const { usageType } = multiUseSettings

  return (
    <Card title={t('title')} isActive={true}>
      <div className="mb-m">
        <div className="d-flex align-items-center mb-xs">
          <Text.BodyText3 className="extra-bold mr-xs">
            {usageType === 'exactly_once'
              ? t('exactly_once_label')
              : t('multiple_times_label')}
          </Text.BodyText3>
        </div>
        <Text.BodyText4 className="grey-70">
          {usageType === 'exactly_once'
            ? t('exactly_once_description')
            : t('multiple_times_description')}
        </Text.BodyText4>
      </div>

      {usageType === 'multiple_times' && (
        <div>
          <div className="mb-m">
            <Text.BodyText4 bold color="grey90" tag="p" className="mb-xs">
              {t('max_issuances_per_window_label')}
            </Text.BodyText4>
            {multiUseSettings.maxIssuancesPerWindow &&
            multiUseSettings.windowDuration ? (
              <>
                <Text.BodyText4 color="grey90" tag="p" className="mb-xs">
                  {t('max_issuances_per_window_set_number')}
                </Text.BodyText4>
                <Text.BodyText4 className="grey-70">
                  {t('max_issuances_per_window_description', {
                    count: multiUseSettings.maxIssuancesPerWindow,
                    days: multiUseSettings.windowDuration,
                  })}
                </Text.BodyText4>
              </>
            ) : (
              <Text.BodyText4 color="grey90" tag="p" className="mb-xs">
                {t('max_issuances_per_window_unlimited')}
              </Text.BodyText4>
            )}
          </div>

          {multiUseSettings.maxIssuances && (
            <div className="mb-m">
              <Text.BodyText4 bold color="grey90" tag="p" className="mb-xs">
                {t('max_redemptions_label')}
              </Text.BodyText4>
              <Text.BodyText4 className="grey-70">
                {t('max_redemptions_limited_description', {
                  count: multiUseSettings.maxIssuances,
                })}
              </Text.BodyText4>
            </div>
          )}

          {multiUseSettings.activeWindowDuration && (
            <div className="mb-m">
              <Text.BodyText4 bold color="grey90" tag="p" className="mb-xs">
                {t('active_window_duration_label')}
              </Text.BodyText4>
              <Text.BodyText4 className="grey-70">
                {t('active_window_duration_description', {
                  days: multiUseSettings.activeWindowDuration,
                })}
              </Text.BodyText4>
            </div>
          )}
        </div>
      )}
    </Card>
  )
}

export default MultiUseCard
